import React, { useContext } from 'react';
import Cookies from "js-cookie";
import { Radio, FormControlLabel, RadioGroup, FormControl, Typography } from '@mui/material';
//icons
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

import { MyDialog } from "../../component/index";

import DataSourceContext from "../../context/DataSourceMngContext";

function Contents() {

  const { setup_servers, selectServer, setDataState } = useContext(DataSourceContext);

  const handleChange = (event, newValue) => {
    setDataState((s) => ({
      ...s,
      selectServer: setup_servers?.find(s => s.name === newValue),
    }));
  };

  return (
    <FormControl>
      <Typography>Select Data Source</Typography>
      <RadioGroup
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={selectServer?.name}
        onChange={handleChange}
      >
        {setup_servers?.map((s, i) => (
          <FormControlLabel
            key={i}
            value={s.name}
            control={
              <Radio
                icon={<PanoramaFishEyeIcon />} // ไอคอนเมื่อไม่ได้เลือก
                checkedIcon={<TaskAltIcon />} // ไอคอนเมื่อเลือก
              />
            }
            label={s.display}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

export default function DialogSelectServer() {

  const { dialog, loading, setDialog, selectServer, setDataState } = useContext(DataSourceContext);

  const handleClose = () => {
    setDialog('select_server', false);
    setDataState((s) => ({
      ...s,
      selectServer: null,
    }));
  };

  const handleConfirm = () => {
    switch (selectServer?.name) {
      case 'microsoft':
        Cookies.set("ds", JSON.stringify(selectServer));
        window.location.href = selectServer?.redirect_url;
        break;
      default:
        break;
    }
  };

  return (
    <MyDialog
      Header="Data Source Setup"
      textConfirm="Configure Data Source"
      open={dialog.select_server}
      disabled={!selectServer}
      handleClose={handleClose}
      loading={loading?.modal}
      handleConfirm={handleConfirm}>
      <Contents />
    </MyDialog>
  );
}